import { formatSipUri, isSipUri } from "@repo/common";

export function normalizePhoneNumberForStorage(
	value: string,
	defaultCountryCode = "972",
): string | null {
	const trimmed = value.trim();
	if (!trimmed) return null;

	const cleaned = trimmed.replace(/[^\d+]/g, "");
	if (!cleaned) return null;

	if (cleaned.startsWith("+")) {
		const digits = cleaned.slice(1).replace(/\D/g, "");
		return digits ? `+${digits}` : null;
	}

	const digits = cleaned.replace(/\D/g, "");
	if (!digits) return null;

	if (digits.startsWith(defaultCountryCode)) {
		return `+${digits}`;
	}

	if (digits.startsWith("0")) {
		return `+${defaultCountryCode}${digits.slice(1)}`;
	}

	return `+${digits}`;
}

export function normalizeTransferTargetForStorage(
	value: string,
	defaultCountryCode = "972",
): string | null {
	const trimmed = value.trim();
	if (!trimmed) return null;

	if (isSipUri(trimmed)) {
		return formatSipUri(trimmed);
	}

	return normalizePhoneNumberForStorage(trimmed, defaultCountryCode);
}

export function normalizePhoneNumberListForStorage(values: string[]): string[] {
	return Array.from(
		new Set(
			values
				.map((value) => normalizePhoneNumberForStorage(value))
				.filter((value): value is string => Boolean(value)),
		),
	).sort((a, b) => a.localeCompare(b));
}

export function normalizeTransferTargetListForStorage(
	values: string[],
	defaultCountryCode = "972",
): string[] {
	return Array.from(
		new Set(
			values
				.map((value) =>
					normalizeTransferTargetForStorage(value, defaultCountryCode),
				)
				.filter((value): value is string => Boolean(value)),
		),
	).sort((a, b) => a.localeCompare(b));
}
